import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import { EmployeeWithdrawalsState, employeeWithdrawalsKey } from '../reducers/employee-withdrawals.reducer';
import * as employeeWithdrawalsState from '../reducers/employee-withdrawals.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, EmployeeWithdrawalsState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Employee GenerateOtp SUB STATE
export const getEmployeeWithdrawalsState = createSelector(getMainEmployeeState, state => state[employeeWithdrawalsKey]);
//#endregion

export const getEmployeeWithdrawalsSuccess = createSelector(
  getEmployeeWithdrawalsState,
  employeeWithdrawalsState.getEmployeeWithdrawalsResponse
);
export const getEmployeeWithdrawalsFailure = createSelector(
  getEmployeeWithdrawalsState,
  employeeWithdrawalsState.getEmployeeWithdrawalsFailure
);
//#endregion
